var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Marque"}},[_c('b-card',[_c('form-brand',{on:{"on-refresh":_vm.init}}),_c('brand-table',{attrs:{"brands":_vm.brands},on:{"on-refresh":_vm.init}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }